<template>
    <div class="flex flex-col dark:text-white">
        <div class="mb-5">
            <h2 class="text-2xl font-bold text-gray-900 dark:text-white">Inclusão manual de membros no Mozart</h2>
            <p class="text-gray-600 dark:text-gray-400">Gerencie a inclusão manual de membros no Mozart</p>
        </div>

        <div class="my-5 flex flex-col">
            <form
                class="flex content-center items-center"
                @submit.prevent="
                    invites = [];
                    next_page_url = false;
                    fetch();
                "
            >
                <div class="grow">
                    <input
                        v-model="filters.email"
                        type="email"
                        id="email"
                        class="text-input"
                        placeholder="Pesquisar por email..."
                    />
                </div>
                <div class="flex items-center ml-4">
                    <label class="inline-flex cursor-pointer items-center">
                        <input
                            v-model="filters.under_migration_period"
                            type="checkbox"
                            class="sr-only peer"
                        />
                        <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:inset-s-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-amber-500"></div>
                        <span class="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300 whitespace-nowrap">
                            Em migração
                        </span>
                    </label>
                </div>
                <div class="flex flex-none ml-4">
                    <button
                        @click.prevent="clearFilters"
                        :disabled="false"
                        type="button"
                        :class="{ 'cursor-not-allowed': loading }"
                        class="mx-2 mr-2 inline-flex items-center rounded-md border-2 border-indigo-500 bg-transparent px-4 py-2 text-sm font-semibold leading-6 text-indigo-500 shadow transition duration-150 ease-in-out hover:bg-indigo-500 hover:text-white"
                    >
                        Limpar filtros
                    </button>
                    <button
                        @click.prevent="
                            invites = [];
                            next_page_url = false;
                            fetch();
                        "
                        :disabled="loading"
                        type="submit"
                        :class="{ 'cursor-not-allowed': loading }"
                        class="mx-auto inline-flex items-center rounded-md bg-indigo-500 px-4 py-2 text-sm font-semibold leading-6 text-white shadow transition duration-150 ease-in-out hover:bg-indigo-400"
                    >
                        <svg
                            v-if="loading"
                            class="-ml-1 mr-3 h-5 w-5 animate-spin text-white"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                        >
                            <circle
                                class="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                stroke-width="4"
                            ></circle>
                            <path
                                class="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                        </svg>
                        Pesquisar
                    </button>
                </div>
            </form>
        </div>

        <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div class="inline-block min-w-full sm:px-6 lg:px-8">
                <div
                    class="not-prose relative overflow-hidden overflow-hidden rounded-xl bg-slate-50 dark:bg-slate-800/25"
                >
                    <table class="w-full table-auto border-collapse text-sm">
                        <thead>
                            <tr>
                                <th
                                    scope="col"
                                    class="px-6 py-4 text-left text-sm font-medium"
                                >
                                    Nome
                                </th>
                                <th
                                    scope="col"
                                    class="px-6 py-4 text-left text-sm font-medium"
                                >
                                    Email
                                </th>
                                <th
                                    scope="col"
                                    class="px-6 py-4 text-left text-sm font-medium"
                                >
                                    Min. Vendas
                                </th>
                                <th
                                    scope="col"
                                    class="px-6 py-4 text-left text-sm font-medium"
                                >
                                    Período (dias)
                                </th>
                                <th
                                    scope="col"
                                    class="px-6 py-4 text-left text-sm font-medium"
                                >
                                    Vendas por acesso
                                </th>
                                <th
                                    scope="col"
                                    class="px-6 py-4 text-left text-sm font-medium"
                                >
                                    Habilitado
                                </th>
                                <th
                                    scope="col"
                                    class="px-6 py-4 text-left text-sm font-medium"
                                >
                                    Ações
                                </th>
                            </tr>
                        </thead>
                        <tbody class="bg-white dark:bg-slate-800">
                            <template v-if="loading">
                                <tr v-for="row in 5" :key="'loading-row-' + row">
                                    <td
                                        v-for="col in 7"
                                        :key="'loading-col-' + col"
                                        class="border-b border-slate-100 p-4 pl-8 text-slate-500 dark:border-slate-700 dark:text-slate-200"
                                    >
                                        <div
                                            class="h-2 w-full animate-pulse rounded bg-gray-500"
                                        ></div>
                                    </td>
                                </tr>
                            </template>
                            <tr v-if="!loading && invites.length === 0">
                                <td
                                    colspan="7"
                                    class="border-b border-slate-100 p-8 text-center text-slate-500 dark:border-slate-700 dark:text-slate-200"
                                >
                                    <div class="text-lg">
                                        Nenhum inclusão manual de membros encontrada
                                    </div>
                                </td>
                            </tr>
                            <template v-if="!loading">
                                <tr v-for="invite in invites" :key="invite.id">
                                <td
                                    class="border-b border-slate-100 p-3 text-slate-500 dark:border-slate-700 dark:text-slate-200"
                                >
                                    {{ invite.name || invite.email }}
                                </td>
                                <td
                                    class="items-center justify-center border-b border-slate-100 p-3 text-slate-500 dark:border-slate-700 dark:text-slate-200"
                                >
                                    {{ invite.email }}
                                </td>
                                <td
                                    class="items-center justify-center border-b border-slate-100 p-3 text-slate-500 dark:border-slate-700 dark:text-slate-200"
                                >
                                    {{ invite.portal_manual_access_control_settings?.min_sales_required || '-' }}
                                </td>
                                <td
                                    class="items-center justify-center border-b border-slate-100 p-3 text-slate-500 dark:border-slate-700 dark:text-slate-200"
                                >
                                    {{ invite.portal_manual_access_control_settings?.sales_period_days || '-' }}
                                </td>
                                <td
                                    class="items-center justify-center border-b border-slate-100 p-3 text-slate-500 dark:border-slate-700 dark:text-slate-200"
                                >
                                    {{ invite.portal_manual_access_control_settings?.sales_per_manual_access || '-' }}
                                </td>
                                <td
                                    class="items-center justify-center border-b border-slate-100 p-3 text-slate-500 dark:border-slate-700 dark:text-slate-200"
                                >
                                    <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                                          :class="{
                                              'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200': invite.portal_manual_access_control_settings?.is_enabled == true,
                                              'bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-200': invite.portal_manual_access_control_settings?.is_enabled == false,
                                              'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200': !invite.portal_manual_access_control_settings
                                          }">
                                        {{ getEnabledLabel(invite.portal_manual_access_control_settings?.is_enabled) }}
                                    </span>
                                </td>
                                                                <td
                                    class="items-center justify-center border-b border-slate-100 p-3 text-slate-500 dark:border-slate-700 dark:text-slate-200"
                                >
                                    <div class="flex space-x-2">
                                        <button
                                            @click="viewMemberDetails(invite)"
                                            class="text-indigo-600 hover:text-indigo-900 hover:underline text-sm"
                                        >
                                            Ver Detalhes
                                        </button>
                                    </div>
                                </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                    <div class="my-5 flex w-full">
                        <div class="mx-auto flex flex-col items-center">
                            <span class="mb-1">
                                Exibindo {{ pagination.from }} a
                                {{ pagination.to }} registros de
                                {{ pagination.total }}
                            </span>
                            <pagination
                                :pagination="pagination"
                                :offset="1"
                                @paginate="fetch"
                            ></pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useToast } from "vue-toastification";
import Pagination from "../../components/layouts/Pagination.vue";

export default {
    components: { Pagination },
    setup() {
        const toast = useToast();
        return { toast };
    },
    data() {
        return {
            loading: false,
            next_page_url: false,
            invites: [],
            pagination: {
                total: 0,
                per_page: 10,
                current_page: 1,
                last_page: 1,
                from: 0,
                to: 0,
            },
            filters: {
                email: "",
                under_migration_period: false,
            },
        };
    },

    mounted() {
        this.fetch();
    },

    watch: {
        'filters.under_migration_period'() {
            this.invites = [];
            this.next_page_url = false;
            this.pagination.current_page = 1;
            this.fetch();
        }
    },

    methods: {
        clearFilters() {
            this.filters.email = "";
            this.filters.under_migration_period = false;
            this.invites = [];
            this.next_page_url = false;
            this.fetch();
        },

        getEnabledLabel(isEnabled) {
            if (isEnabled == true) return 'Habilitado';
            if (isEnabled == false) return 'Desabilitado';
            return 'Não configurado';
        },
        formatDate(dateString) {
            if (!dateString) return '';
            return new Date(dateString).toLocaleDateString('pt-BR');
        },
        viewMemberDetails(invite) {
            this.$router.push({
                name: 'auditoria.mozart.invite-member-details',
                params: { user: invite.id || invite.user_id || 1 }
            });
        },
        async fetch() {
            this.loading = true;

            try {
                const params = {
                    page: this.pagination.current_page,
                };

                if (this.filters.email) {
                    params["filter[email]"] = this.filters.email;
                }

                if (this.filters.under_migration_period) {
                    params["filter[under_migration_period]"] = true;
                }

                const { data } = await axios.get("/api/auditoria/invite-members", { params });

                this.invites = data.data;
                this.pagination = {
                    ...this.pagination,
                    ...data,
                };
                this.next_page_url = data.next_page_url;
            } catch (error) {
                this.$toast.error("Erro ao carregar dados");
                console.error("Fetch error:", error);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
